<template>
	<div class="wrapper">
		<div v-if="loading && officeList.length === 0" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<template v-slot:header>
							<i class="icon-pencil"></i> Clone temporary allocations to replaced device
						</template>
						<b-card-body>
							<b-form>
								<b-form-group
									label="Select Office"
									label-for="office-list"
									:label-cols="3"
									:horizontal="true">
									<model-select
										id="office-list"
										:options="officeList"
										v-model="selectedOfficeId"
										placeholder="Please Select">
									</model-select>
								</b-form-group>
								<div v-if="selectedOfficeId != null">
									<div v-if="loading" class="text-center">
										<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
									</div>
									<div v-else>
										<b-form-group
											label="Clone From Device"
											label-for="source-device-list"
											:label-cols="3"
											:horizontal="true">
											<model-select
												id="source-device-list"
												:options="sourceDeviceList"
												v-model="selectedSourceDeviceId"
												placeholder="Please Select">
											</model-select>
										</b-form-group>
										<b-form-group
											label="Clone To Device"
											label-for="source-device-list"
											:label-cols="3"
											:horizontal="true">
											<model-select
												id="source-device-list"
												:options="targetDeviceList"
												v-model="selectedTargetDeviceId"
												placeholder="Please Select">
											</model-select>
										</b-form-group>
									</div>
								</div>
								<div class="form-actions">
									<b-button v-if="!disableSubmission" v-on:click="validateForm()" variant="primary">
									<i class="fa fa-clone"></i> Clone Data
									</b-button>
									<b-button v-else variant="primary" disabled>
										<b-spinner small></b-spinner>
										Please Wait...
									</b-button>
								</div>
							</b-form>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import officeService from "@/services/officeService";
import {ModelSelect} from "vue-search-select";
import toastService from '@/services/toastService';
import customerSupportService from "@/services/customerSupportService";

export default {
	name: "CloneTemporaryAllocations",
	components : {
		ModelSelect
	},
	data : function () {
		return {
			loading : false,
			officeList : [],
			deviceList : [],
			selectedOfficeId : null,
			selectedSourceDeviceId : null,
			selectedTargetDeviceId : null,
			sourceDeviceList : [],
			targetDeviceList : [],
			disableSubmission : false
		};
	},
	methods : {
		getOfficeList : function () {
			officeService.getOfficeList( r => {
				this.officeList = this.createOfficeDropDownList(r);
				this.loading = false;
			});
		},
		createOfficeDropDownList: function (data) {
			let officeList = [ {text: 'Please select', value: null} ];
			data.forEach((value, index) => {
				let office = new Object();
				office.text = value.name;
				office.value = value.id;
				officeList.push(office);
			});

			return officeList;
		},
		getDevicesOfSelectedOffice : function () {
			this.loading = true;
			this.sourceDeviceList = [];
			this.targetDeviceList = [];
			officeService.getDevicesOfAnOffice(this.selectedOfficeId,(data) => {
				this.loading = false;
				this.deviceList = data;
				this.sourceDeviceList = this.createSourceDeviceDropDownList(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch device list" + error);
				this.loading = false;
			});
		},
		createSourceDeviceDropDownList: function (data) {
			let deviceList = [ {text: 'Please select', value: null} ];
			data.forEach((value, index) => {
				let device = new Object();
				device.text = value.identifier;
				device.value = value.id;
				deviceList.push(device);
			});

			return deviceList;
		},
		createTargetDeviceDropDownList: function () {
			this.targetDeviceList = [];
			let deviceList = [ {text: 'Please select', value: null} ];
			this.deviceList.forEach((value, index) => {
				if(value.id !== this.selectedSourceDeviceId) {
					let device = new Object();
					device.text = value.identifier;
					device.value = value.id;
					deviceList.push(device);
				}
			});

			this.targetDeviceList = deviceList;
		},
		validateForm : function () {
			if(this.selectedOfficeId == null)
				return toastService.showErrorToast("Please select an office");
			if(this.selectedSourceDeviceId == null)
				return toastService.showErrorToast("Please select the source device");
			if(this.selectedTargetDeviceId == null)
				return toastService.showErrorToast("Please select the target device");
			if(this.selectedSourceDeviceId === this.selectedTargetDeviceId)
				return toastService.showErrorToast("Please select different devices as source and target");
			this.submitForm();
		},
		submitForm : function() {
			this.disableSubmission = true;
			let formData = {
				officeId : this.selectedOfficeId,
				sourceDeviceId : this.selectedSourceDeviceId,
				targetDeviceId : this.selectedTargetDeviceId
			};

			customerSupportService.cloneTemporaryAllocations(formData, (data) => {
				this.disableSubmission = false;
				toastService.showSuccessToast("Temporary allocations cloning successful");
			}, (error) => {
				this.disableSubmission = false;
				toastService.showErrorToast("Could not clone temporary allocations, " + error);
			});
		}
 	},
	created() {
		this.loading = true;
		this.getOfficeList()
	},
	mounted() {

	},
	watch : {
		selectedOfficeId : function (newVal) {
			if(newVal !== null) this.getDevicesOfSelectedOffice();
		},
		selectedSourceDeviceId : function (newVal) {
			if(newVal !== null) this.createTargetDeviceDropDownList();
		}
	}
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
